// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__y3mIE","errors":"Errors_errors__uYbCh"};